module.exports = __webpack_public_path__ + "static/media/old_outcome_version_2.bc3de186.png";